import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { notification } from './notification.reducer';
import { project } from './project.reducer';
import { content_label } from './content_label.reducer';
import { work_space } from './work_space.reducer';
import { multiUser } from './multi_user.reducer';
import { workspaceUser } from './workspace_user.reducer';
import { content } from './content.reducer';
import { content_group } from './content_group.reducer';
import { dashboard } from './dashboard.reducer';
import { user_profile } from './user_profile.reducer';
import { stage } from './stage.reducer';
import { template_stage } from './template_stage.reducer';
import { comment } from './comment.reducer';
import { chat } from './chat.reducer';
import { assigned_user } from './assigned_user.reducer';
import { search_history } from './search_history.reducer';
import { organization } from './organization.reducer';
import { list } from './list.reducer';
import { invalid_stage_popup } from './invalid_stage_popup.reducer';
import { card_popup_modal } from './card_popup_reducer';
import { minimized_card } from './minimized_card.reducer';
import { card_settings_dropdown } from './card_settings_dropdown.reducer';
import { card_duplicate } from './card_duplicate.reducer';
import { card_delete_popup } from './card_delete_popup.reducer';
import { new_stage_popup } from './new_stage_popup.reducer';
import { participant_popup } from './participant_popup.reducer';
import { sidebar } from './sidebar.reducer';
import { notification_filter } from './notification_filter.reducer';
import { popup_dismiss } from './popup_dismiss.reducer';
import { calendar } from './calendar.reducer';
import { card_visit } from './card_visit.reducer';
import { subscription_ping } from './subscription_ping.reducer';

const rootReducer = combineReducers({
  content_label,
  authentication,
  registration,
  users,
  alert,
  notification,
  work_space,
  multiUser,
  workspaceUser,
  content,
  content_group,
  dashboard,
  user_profile,
  stage,
  template_stage,
  comment,
  chat,
  assigned_user,
  search_history,
  organization,
  list,
  invalid_stage_popup,
  card_popup_modal,
  minimized_card,
  card_settings_dropdown,
  card_duplicate,
  card_delete_popup,
  new_stage_popup,
  participant_popup,
  sidebar,
  notification_filter,
  popup_dismiss,
  calendar,
  card_visit,
  subscription_ping,
  form: formReducer
});

export default rootReducer;
